export const selectedClientEntityKey = 'cko-dashboard-selected-client-entity';
export const SELECTED_CLIENT_KEY = 'cko-dashboard-selected-client';
export const SELECTED_ENTITY_KEY = 'cko-dashboard-selected-entity';
export const SELECTED_SEGMENT_KEY = 'cko-dashboard-selected-segment';
export const USER_ID_KEY = 'cko-dashboard-user-id';
export const SELECTED_TIME_ZONE_KEY = 'cko-selected-time-zone';
